export default __webpack_public_path__ + "static/media/galerie1.90c77652.jpg";